import React, { useEffect } from "react";
import UserScreenWindow from "../Components/UserScreenWindow";
import { useParams } from "react-router-dom";
import {
  getAllDocsSnap,
  getDocDataSnap,
  setDocData,
} from "../../../utils/firebase/Firebase.utils";
import { storage } from "../../../utils/firebase/Firebase.utils";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { parse, v4 } from "uuid";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { notifyBillPayment } from "../../../utils/userActivityNotifier";
import { createBillPaymentNotification } from "../../../utils/userNotificationHelper";
import {
  FiDollarSign,
  FiClipboard,
  FiCalendar,
  FiUpload,
  FiCheck,
  FiAlignLeft,
  FiCreditCard,
  FiInfo,
} from "react-icons/fi";
import InputBox from "../../Dashboard/Components/InputBox";
import {
  storeNotification,
  createAdminPaymentNotification,
} from "../../../services/notificationService";
import { sendNotification } from "../../../utils/notifications";
import { addNewNotification } from "../../../utils/EleghoUtils";
import IOSSpinner from "../../../components/IOSSpinner";
import bpi from "../assets/bpi.png";
import unionbank from "../assets/unionbank.png";
import bdo from "../assets/bdo.jpg";
import landbank from "../assets/landbank.png";
import metrobank from "../assets/metrobank.png";
import billease from "../assets/billease.jpg";
import creditcard from "../assets/creditcard.png";
import grabpay from "../assets/grabpay.png";
import maya from "../assets/maya.jpg";
import qrph from "../assets/qrph.png";
import { adminEmailAddress, appURL } from "../../../utils/constants";

function BillingDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [billDetails, setBillDetails] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(true);
  const [depositSlip, setDepositSlip] = React.useState(null);
  const [remarks, setRemarks] = React.useState("");
  const [isProcessing, setIsProcessing] = React.useState(false);
  const [progress, setProgress] = React.useState(0);
  const currentUser = useSelector((state) => state.userObject);
  const [showPaymentOptions, setShowPaymentOptions] = React.useState(true);
  const [paymentMethod, setPaymentMethod] = React.useState(null);
  const [fees, setFees] = React.useState(0);

  const cancelUrl = `${appURL}/billing-details/${id}`;

  // useEffect(() => {
  //   const fetchPayments = async () => {
  //     await getAllDocsSnap("payments", (data) => {
  //       console.log(data);
  //     });
  //   };
  //   fetchPayments();
  // }, []);

  useEffect(() => {
    const fetchBillDetails = async () => {
      await getDocDataSnap("billings", id, (data) => {
        setBillDetails(data);
        setIsLoading(false);
      });
    };
    fetchBillDetails();
  }, []);

  if (isLoading) {
    return (
      <UserScreenWindow label="Billing Details">
        <div className="flex items-center justify-center h-64">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-eleghoBlue"></div>
        </div>
      </UserScreenWindow>
    );
  }

  const handleUpload = (e) => {
    const file = e.target.files[0];
    const storageRef = ref(storage, `depositSlips/${file.name}`);
    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        switch (snapshot.state) {
          case "paused":
            break;
          case "running":
            break;
        }
        setProgress(progress);
      },
      (error) => {
        toast.error("Error uploading file");
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          setDepositSlip(downloadURL);
          toast.success("File uploaded successfully");
        });
      }
    );
  };

  const handleChange = (e) => {
    const { value, name } = e.target;
    setRemarks(value);
  };

  const handleSelectPaymentMethod = (option) => {
    setPaymentMethod(option);
  };

  const handleSubmit = async () => {
    if (!depositSlip) {
      toast.error("Please upload a deposit slip");
      return;
    }

    setIsProcessing(true);
    const paymentId = v4();
    const data = {
      status: "deposit slip uploaded",
      paymentDate: new Date().toLocaleDateString(),
      paymentId: paymentId,
      depositSlip: depositSlip,
      userEmail: currentUser.email,
      remarks: remarks,
    };
    await setDocData("billings", id, data);

    //notify admin about the bill payment
    const fcmNotification = {
      title: "Bill Payment",
      body: `A new bill payment has been made`,
      data: {
        id: id,
      },
    };

    await sendNotification(adminEmailAddress, fcmNotification);

    const firestoreNotification = {
      to: adminEmailAddress,
      user: "admin",
      from: currentUser.email,
      fromName: currentUser.displayName,
      subject: "Bill Payment",
      message: `A new bill payment has been made by ${currentUser.displayName} of ${billDetails.identifier}`,
      dateTime: new Date(),
      id: id,
      read: false,
    };

    await addNewNotification(firestoreNotification);

    navigate(`/payment-confirmed/${id}`);
  };

  const handleComputeFees = (amount) => {
    // make sure amount is a number
    if (isNaN(amount)) {
      toast.error("Invalid amount");
      return 0;
    }

    if (paymentMethod === "card") {
      const gross = (Number(amount) + 15) / (1 - 0.035);
      const fees = gross - amount;
      const roundedFees = parseFloat(fees.toFixed(2));
      return roundedFees;
    }

    if (paymentMethod === "qrph") {
      const gross = Number(amount) / (1 - 0.015);
      const fees = gross - amount;
      const roundedFees = parseFloat(fees.toFixed(2));
      return roundedFees;
    }

    if (paymentMethod === "dob") {
      if (amount < 1867) {
        return 15;
      }
      const gross = Number(amount) / (1 - 0.008);
      const fees = gross - amount;
      const roundedFees = parseFloat(fees.toFixed(2));
      return roundedFees;
    }

    return 15;
  };

  // checkout session for paymongo
  const handlePaymongoCheckout = async () => {
    // check if payment method is selected
    if (!paymentMethod) {
      toast.error("Please select a payment method");
      return;
    }

    setIsProcessing(true);

    const fees = handleComputeFees(billDetails.billingAmount);

    //delay 1 second
    await new Promise((resolve) => setTimeout(resolve, 1000));

    const options = {
      method: "POST",
      headers: {
        accept: "application/json",
        "Content-Type": "application/json",
        authorization: process.env.REACT_APP_PAYMONGO_API_KEY,
      },
      body: JSON.stringify({
        data: {
          attributes: {
            send_email_receipt: true,
            show_description: true,
            show_line_items: true,
            line_items: [
              {
                currency: "PHP",
                amount:
                  parseInt(billDetails.billingAmount, 10) * 100 + fees * 100,
                description: `Payment for ${billDetails.identifier} - ${billDetails.description} - ${billDetails.soaNumber}`,
                name: currentUser.displayName,
                quantity: 1,
              },
            ],
            payment_method_types: [paymentMethod],
            description: `Payment for ${billDetails.identifier} - ${billDetails.description} - ${billDetails.soaNumber}`,
            reference_number: id,
            cancel_url: `${appURL}/billing-details/${id}`,
            success_url: `${appURL}/payment-confirmed/${id}`,
            statement_descriptor: `Payment for ${billDetails.description}`,
          },
        },
      }),
    };

    await fetch("https://api.paymongo.com/v1/checkout_sessions", options)
      .then((response) => response.json())
      .then(async (response) => {
        await setDocData("billings", id, {
          status: "unpaid",
          paymentDate: new Date().toLocaleDateString(),
          paymentId: response.data.id,
          method: "paymongo",
          checkout_session_id: response.data.id,
          response: response,
        });

        await setDocData("sessions", response.data.id, response);
        window.location.href = response.data.attributes.checkout_url;
      })
      .catch((err) => console.error(err));

    setIsProcessing(false);
  };

  // payment method options
  const paymentOptions = [
    {
      name: "BDO",
      value: "brankas_bdo",
      logo: bdo,
    },
    {
      name: "Landbank",
      value: "brankas_landbank",
      logo: landbank,
    },
    {
      name: "Metrobank",
      value: "brankas_metrobank",
      logo: metrobank,
    },
    {
      name: "Billease",
      value: "billease",
      logo: billease,
    },
    {
      name: "Credit Card",
      value: "card",
      logo: creditcard,
    },
    {
      name: "BPI",
      value: "dob",
      logo: bpi,
    },
    {
      name: "Unionbank",
      value: "dob_ubp",
      logo: unionbank,
    },
    {
      name: "Grab Pay",
      value: "grab_pay",
      logo: grabpay,
    },
    {
      name: "Paymaya",
      value: "paymaya",
      logo: maya,
    },
    {
      name: "QRPH",
      value: "qrph",
      logo: qrph,
    },
  ];

  const findMethodName = (paymentMethod) => {
    const method = paymentOptions.find(
      (option) => option.value === paymentMethod
    );
    return method ? method.name : "Unknown Method";
  };

  return (
    <UserScreenWindow label="Billing Details">
      <div className="w-full mx-auto p-4">
        {/* Header */}
        <div className="text-center mb-6">
          <h1 className="text-lg font-semibold text-[#363062] mb-1">
            Billing Details
          </h1>
          <p className="text-sm text-gray-500">
            Complete your payment securely
          </p>
        </div>

        {/* Main Content Grid */}
        <div className="flex flex-col gap-4">
          {/* Left Column - Bill Details */}
          <div className="lg:col-span-2 space-y-4">
            {/* Bill Summary Card */}
            <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-4">
              <div className="flex items-center gap-2 mb-3">
                <FiInfo className="w-4 h-4 text-[#363062]" />
                <span className="text-sm font-medium text-[#363062]">
                  Bill Summary
                </span>
              </div>
              <div className="space-y-3">
                <div className="flex justify-between items-center py-2 border-b border-gray-50">
                  <div className="flex items-center gap-2">
                    <FiClipboard className="w-4 h-4 text-[#363062]" />
                    <span className="text-xs text-gray-600">Reference</span>
                  </div>
                  <span className="text-sm font-medium text-[#363062]">
                    {billDetails?.identifier || "N/A"}
                  </span>
                </div>
                <div className="flex justify-between items-center py-2 border-b border-gray-50">
                  <div className="flex items-center gap-2">
                    <FiDollarSign className="w-4 h-4 text-[#8FCD00]" />
                    <span className="text-xs text-gray-600">Amount Due</span>
                  </div>
                  <span className="text-sm font-medium text-[#8FCD00]">
                    ₱ {billDetails?.amount}
                  </span>
                </div>
                <div className="flex justify-between items-center py-2 border-b border-gray-50">
                  <div className="flex items-center gap-2">
                    <FiCalendar className="w-4 h-4 text-[#363062]" />
                    <span className="text-xs text-gray-600">Due Date</span>
                  </div>
                  <span className="text-sm text-[#363062]">
                    {billDetails?.dueDate}
                  </span>
                </div>
                <div className="flex justify-between items-center py-2">
                  <div className="flex items-center gap-2">
                    <FiCheck className="w-4 h-4 text-[#363062]" />
                    <span className="text-xs text-gray-600">Status</span>
                  </div>
                  <span className="text-sm font-medium capitalize px-2 py-1 bg-[#363062]/10 rounded-full text-[#363062]">
                    {billDetails?.status}
                  </span>
                </div>
              </div>
            </div>

            {/* Description Card */}
            <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-4">
              <div className="flex items-center gap-2 mb-3">
                <FiAlignLeft className="w-4 h-4 text-[#363062]" />
                <span className="text-sm font-medium text-[#363062]">
                  Description
                </span>
              </div>
              <p className="text-sm text-gray-600">
                {billDetails?.description}
              </p>
            </div>
          </div>

          {/* Right Column - Payment Options */}
          <div className="lg:col-span-1 space-y-4">
            {/* Online Payment Card */}
            <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-4">
              <div className="flex items-center gap-2 mb-3">
                <FiCreditCard className="w-4 h-4 text-[#363062]" />
                <span className="text-sm font-medium text-[#363062]">
                  Pay Online - Select from the options below
                </span>
              </div>
              {showPaymentOptions && (
                <div className="grid grid-cols-4 gap-4 mb-4">
                  {paymentOptions.map((option, index) => (
                    <div
                      key={index}
                      onClick={() => handleSelectPaymentMethod(option.value)}
                      className={`flex flex-col items-center justify-center p-2 rounded-lg  cursor-pointer hover:bg-[#363062]/10 transition-colors text-center ${
                        paymentMethod === option.value
                          ? "border-2 border-eleghoBlue shadow-lg"
                          : "border border-gray-200"
                      }`}
                    >
                      <img
                        src={option.logo}
                        className="object-contain h-[50px] w-[50px]"
                        alt=""
                      />
                      <div className="text-[10px] text-center text-gray-600 font-semibold">
                        {option.name}
                      </div>
                    </div>
                  ))}
                </div>
              )}
              <button
                className="w-full bg-[#8FCD00] text-white py-2 px-3 rounded-lg text-sm font-medium hover:bg-[#8FCD00]/90 transition-colors flex items-center justify-center gap-2"
                onClick={handlePaymongoCheckout}
                disabled={isProcessing}
              >
                {isProcessing ? (
                  <span className="flex items-center gap-2">
                    Processing <IOSSpinner />
                  </span>
                ) : (
                  "Pay Now"
                )}
              </button>
              <p className="text-xs text-gray-500 text-center mt-2 font-medium">
                {paymentMethod && (
                  <div className="mt-3 p-2 bg-gray-50 rounded-lg border border-gray-100">
                    <div className="flex items-center gap-1 mb-1">
                      <FiInfo className="w-3 h-3 text-[#363062]" />
                      <span className="text-xs font-medium text-[#363062]">
                        Payment Breakdown
                      </span>
                    </div>
                    <div className="grid grid-cols-2 gap-1">
                      <div className="text-xs text-gray-600">Amount:</div>
                      <div className="text-xs font-medium text-right">
                        ₱{billDetails?.billingAmount}
                      </div>
                      <div className="text-xs text-gray-600">
                        Bank Convenience Fee:
                      </div>
                      <div className="text-xs font-medium text-right">
                        ₱{handleComputeFees(billDetails.billingAmount)}
                      </div>
                      <div className="text-xs font-medium text-[#363062] pt-1 border-t border-gray-200">
                        Total:
                      </div>
                      <div className="text-xs font-medium text-[#8FCD00] text-right pt-1 border-t border-gray-200">
                        ₱
                        {parseInt(billDetails.billingAmount, 10) +
                          handleComputeFees(billDetails.billingAmount)}
                      </div>
                    </div>
                    <div className="flex items-center gap-1 mt-2 text-[10px] text-gray-500">
                      <FiCreditCard className="w-3 h-3" />
                      <span>Paying with {findMethodName(paymentMethod)}</span>
                    </div>
                  </div>
                )}
              </p>
            </div>

            <div>
              <p className="text-xs text-gray-500 text-left mt-2 font-medium">
                Or you can pay via bank deposit. Please upload your deposit slip
                below.
              </p>
            </div>

            {/* Upload Slip Card */}
            <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-4">
              <div className="flex items-center gap-2 mb-3">
                <FiUpload className="w-4 h-4 text-[#363062]" />
                <span className="text-sm font-medium text-[#363062]">
                  Upload Payment Slip
                </span>
              </div>
              <div className="border-2 border-dashed border-gray-200 rounded-lg p-3 text-center">
                <input
                  type="file"
                  onChange={handleUpload}
                  className="hidden"
                  id="deposit-slip"
                  accept="image/*"
                />
                <label htmlFor="deposit-slip" className="cursor-pointer block">
                  <FiUpload className="w-6 h-6 text-gray-400 mx-auto mb-2" />
                  <div className="text-xs text-gray-600 text-center">
                    Click to upload slip
                  </div>
                </label>
              </div>
              {progress > 0 && (
                <div className="mt-2 space-y-1">
                  <div className="h-1.5 bg-gray-100 rounded-full overflow-hidden">
                    <div
                      className="h-full bg-[#363062] transition-all duration-300"
                      style={{ width: `${progress}%` }}
                    ></div>
                  </div>
                  <div className="text-xs text-gray-500 text-center">
                    {Math.round(progress)}%
                  </div>
                </div>
              )}

              {/* Remarks Input */}
              <div className="mt-3">
                <div className="text-xs text-gray-600 mb-1">Remarks</div>
                <InputBox
                  name="remarks"
                  onChange={handleChange}
                  placeholder="Add payment details..."
                  value={remarks}
                  required
                  className="w-full text-sm"
                />
              </div>

              {/* Submit Button */}
              <button
                className="w-full mt-3 bg-[#363062] text-white py-2 px-3 rounded-lg text-sm font-medium hover:bg-[#363062]/90 transition-colors flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
                onClick={handleSubmit}
                disabled={isProcessing || !depositSlip}
              >
                {isProcessing ? (
                  <span className="flex items-center gap-2">
                    Processing <IOSSpinner />
                  </span>
                ) : (
                  "Submit Payment"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </UserScreenWindow>
  );
}

export default BillingDetails;
